/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { tv } from 'tailwind-variants';
import ModalWrapper from 'helpers/GenericWrappers/ModalWrapper/ModalWrapper';
import { withStandardComponentWrapper } from 'helpers/HOC';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import useDictionary from 'lib/hooks/useDictionary';
import useIsEditing from 'lib/hooks/useIsEditing';
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import { getTestProps } from 'lib/testing/utils';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
/*
 * RENDERING
 */ const Modal = (props)=>{
    const { label, modalId, openOnLoad, size, title } = props?.fields || {};
    const { DynamicPlaceholderId } = props?.params || {};
    const { getDictionaryValue } = useDictionary();
    const isEditing = useIsEditing();
    const placeholderKey = `custom-modal-${DynamicPlaceholderId}`;
    if (isEditing) {
        const { base, urlHash } = TAILWIND_VARIANTS();
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: base(),
                    "data-component": "authorable/shared/content/modal",
                    ...editingHydrationProps(isEditing),
                    children: [
                        /*#__PURE__*/ _jsx(PlainTextWrapper, {
                            editable: true,
                            field: title,
                            tag: "h2"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                                name: placeholderKey,
                                rendering: props.rendering
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsxs("p", {
                            className: urlHash(),
                            children: [
                                /*#__PURE__*/ _jsx("em", {
                                    className: "ee-help-text-highlight",
                                    children: getDictionaryValue('ModalURLHash')
                                }),
                                "\xa0 #modal-",
                                /*#__PURE__*/ _jsx(PlainTextWrapper, {
                                    editable: true,
                                    field: modalId,
                                    tag: "span"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "ee-help-text-block",
                            children: getDictionaryValue('ModalURLHint')
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(ModalWrapper, {
        content: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
            name: placeholderKey,
            rendering: props.rendering
        }),
        "data-component": "authorable/shared/content/modal",
        ...editingHydrationProps(isEditing),
        id: modalId?.value,
        label: label?.value,
        openOnLoad: openOnLoad?.value,
        size: size?.value,
        title: title?.value,
        ...getTestProps(`component-modal-${props?.rendering?.uid}`)
    });
};
export const Default = withStandardComponentWrapper(Modal);
const TAILWIND_VARIANTS = tv({
    slots: {
        base: [
            'border',
            'flex',
            'flex-col',
            'gap-5',
            'p-5',
            'rounded'
        ],
        urlHash: [
            'my-2'
        ]
    }
});
